import React, { useRef, useState } from 'react';
import { Carousel, Button } from 'antd';
import { ModalComponent } from '@comps/components';
import { fileUrl } from '@utils/axios';
import { LeftOutlined, RightOutlined, DownloadOutlined } from '@ant-design/icons';

/**
 * Full-size viewer for a case's photos or x-rays.
 *
 * `startIndex` is the thumbnail that was clicked. The carousel used to
 * open on slide 0 no matter which thumbnail opened it, so clicking the
 * third or fourth photo showed the first one — see the callers in
 * UserCaseDetail.
 */
const ViewImages = (props) => {
  const carouselRef = useRef(null);
  const images = props.images || [];
  // Guard the index rather than trusting it: a caller that passes
  // nothing, or an index past the end, still opens on a real slide.
  const startIndex = Math.min(Math.max(props.startIndex || 0, 0), Math.max(images.length - 1, 0));
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  const handleBeforeChange = (_, next) => {
    setCurrentIndex(next);
  };

  const downloadImage = async () => {
    const image = images[currentIndex];
    if (!image) return;
    const imageUrl = fileUrl(image.path);

    try {
      const response = await fetch(imageUrl, { mode: 'cors' });
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${image.name}`; // customize filename if needed
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };


  return (
    <ModalComponent width={ '30%' } open={ true } footer={ false } onCancel={ () => props.onClosed(false) }>
      <div style={ { position: 'relative', width: '100%', height: '100%' } }>
        {/* Carousel */ }
        <Carousel
          ref={ carouselRef }
          infinite={ false }
          dots={ false }
          initialSlide={ startIndex }
          beforeChange={ handleBeforeChange }
        >
          { images.map((image, index) => (
            <div key={ index }>
              <img
                src={ fileUrl(image.path) }
                alt={ `Image ${index + 1}` }
                width={ '100%' }
              />
            </div>
          )) }
        </Carousel>
      </div>

      {/* Controls */ }
      <div style={ { display: 'flex', marginTop: 10, justifyContent: 'center', gap: 10 } }>
        <Button type="primary" onClick={ () => carouselRef.current.prev() }>
          <LeftOutlined />
        </Button>
        <Button type="default" onClick={ downloadImage }>
          <DownloadOutlined /> Download
        </Button>
        <Button type="primary" onClick={ () => carouselRef.current.next() }>
          <RightOutlined />
        </Button>
      </div>
    </ModalComponent>
  );
};

export default ViewImages;
